import { ID_NUMBER } from "../idNumber";

export const buildWhereFromMapToKr = (feature: __esri.Graphic | null) => {
	let where = "1=1";
	if (feature) {
		const layerKey = feature?.attributes["_layerKey"];
		const idName = feature?.attributes["idName"];
		const id = feature?.attributes[ID_NUMBER];
		where += ` AND ${ID_NUMBER}=${id}`;
		if (idName === "dataBase" || idName === "waitingRoom") {
			if (layerKey === "O") {
				where += " AND RODZAJ_OBIEKTU IN('KRO','POO')";
			} else if (layerKey === "TZ") {
				where += " AND RODZAJ_OBIEKTU IN('KRTZ','POTZ')";
			}
		}
	} else {
		return "0=1";
	}
	return where;
}

export const fromTableToMap = (ts: { [id: string] : __esri.Graphic | null }, features: __esri.Graphic[]) => {
	let newRec: any = null;
	let newTs: { [id: string]: __esri.Graphic | null } = {};

	features.forEach(f => {
		var objectType = f.attributes.RODZAJ_OBIEKTU;
		var idNumber = f.attributes.NUMER_IDENTYFIKACYJNY;
		const fKey = getObjKey(objectType, idNumber);
		if (ts.hasOwnProperty(fKey) === false) {
			newRec = f;
		} else {
			if (newTs.hasOwnProperty(fKey) === false) {
				newTs[fKey] = ts[fKey];
			}
		}
	});
	
	return {ts: newTs, newRec: newRec};
}

export const getObjKey = (objectType: string, idNumber: number) => {
	if (objectType === 'KRO' || objectType === 'POO') {
		return `O${idNumber}`;
	}
	if (objectType === 'KRTZ' || objectType === 'POTZ') {
		return `T${idNumber}`;
	}
	return 'unknown';
}
